import React from 'react'
import { Fragment, useRef, useState, useEffect } from 'react'
import { PostData } from '../Services/httpHandelars'
import { Dialog, Transition } from '@headlessui/react'
import { useGlobalContext } from '../context'

export default function Snackbar({snackType, message , status, setSnacBar}) {

    if(snackType === "Success"){
        return(
            <Transition.Root show={status} as={Fragment}>
            <Dialog as="div" className="absolute bottom-0 left-0 z-10" onClose={()=>setSnacBar(false)} >
                <div className={`z-10 inset-0 overflow-y-auto mb-4`}>
                    <div className="m-2  bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative w-96" role="alert">
                        <strong className="font-bold">Success! </strong>
                        <span className="block sm:inline">{message}</span>
                        <span className="absolute top-0 bottom-0 right-0 py-3" onClick={()=>setSnacBar(true )}>
                            <svg className="fill-current h-6 w-6 text-green-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                        </span>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>

        )
    }else if (snackType === "Error"){
        return(

            <Transition.Root show={status} as={Fragment}>
            <Dialog as="div" className="absolute bottom-0 left-0 z-10" onClose={()=>setSnacBar(false)} >
                <div className={`z-10 inset-0 overflow-y-auto mb-4`}>
                    <div className="m-2  bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative w-96" role="alert">
                        <strong className="font-bold">Error! </strong>
                        <span className="block sm:inline">{message}</span>
                        <span className="absolute top-0 bottom-0 right-0 py-3" onClick={()=>setSnacBar(true)}>
                            <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                        </span>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
        
            )

    }else{
        return(

            <Transition.Root show={status} as={Fragment}>
            <Dialog as="div" className="absolute bottom-0 left-0 z-10" onClose={()=>setSnacBar(false)} >
                <div className={`z-10 inset-0 overflow-y-auto mb-4`}>
                    <div className="m-2  bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative w-96" role="alert">
                        <strong className="font-bold">Warning! </strong>
                        <span className="block sm:inline">{message}</span>
                        <span className="absolute top-0 bottom-0 right-0 py-3" onClick={()=>setSnacBar(true)}>
                            <svg className="fill-current h-6 w-6 text-yellow-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
                        </span>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>

)
    }

    
}
